import { render, staticRenderFns } from "./CampaignsDataTable.vue?vue&type=template&id=3343dd65&scoped=true&"
import script from "./CampaignsDataTable.vue?vue&type=script&lang=js&"
export * from "./CampaignsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsDataTable.vue?vue&type=style&index=0&id=3343dd65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3343dd65",
  null
  
)

export default component.exports